import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { DemoAccountForm } from "./DemoAccountForm";
import { useNotification } from "../../../common/hooks/useNotification";

interface IDemoAccountCreateProps {}

export const DemoAccountCreate = (props: IDemoAccountCreateProps) => {
  const notify = useNotification(props, "createSuccess");
  return (
    <Create
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="Create a demo account"
    >
      <DemoAccountForm />
    </Create>
  );
};
